(function() {
    'use strict';

    angular
        .module('receiptApp')
        .controller('ProposalController', ProposalController);

     ProposalController.$inject = ['$scope', '$state', '$filter', '$location', 'CONST_RECEIPT','CommonService', 'CONST_COMMON', 
                                   'ReceiptService','$uibModal', 'CustomerService', 'GLOBAL_URL', 'entity', '$timeout', '$sce', '$base64', 'mode', '$stateParams','Upload'];

    function ProposalController ($scope,  $state, $filter,$location, CONST_RECEIPT, CommonService, CONST_COMMON, 
    					ReceiptService, $uibModal, CustomerService, GLOBAL_URL, entity, $timeout, $sce, $base64, mode, $stateParams, Upload) {
    	var proposalCtr = this;
    	var self = $scope;
    	var receiptScope = self.$parent.$parent;
    	receiptScope.mode = mode;
    	receiptScope.txnId = null;
    	self.isRevert = true;
    	self.investmentFund = {};
    	/*
    	 * Function
    	 */
    	proposalCtr.getCustomerByIdNum = getCustomerByIdNum;
    	proposalCtr.checkProposalNumIsExist = checkProposalNumIsExist;
    	proposalCtr.receiptCancelReason = receiptCancelReason;
    	proposalCtr.checkReceiptDate = checkReceiptDate;
    	proposalCtr.setLocationCode = setLocationCode;
    	proposalCtr.checkAmountThan0 = checkAmountThan0;
    	proposalCtr.checkRuleAgent = checkRuleAgent;
    	proposalCtr.checkPruquoteCode = checkPruquoteCode;
    	proposalCtr.calculateAgePo1 = calculateAgePo1;
    	proposalCtr.calculateAgePo2 = calculateAgePo2;
    	proposalCtr.getCustomerType = function(){
    		return $state.is(CONST_RECEIPT.STATE_INDIVIDUAL) ? CONST_RECEIPT.CUSTOMER_TYPE_INDIVIDUAL : CONST_RECEIPT.CUSTOMER_TYPE_CORPORATION;
    	}
    	proposalCtr.goByContestPayment = function(){
    		$state.go(CONST_RECEIPT.STATE_CONTEST);
    	}
    	proposalCtr.getPruquoteCode = getPruquoteCode;
    	/*
    	 * InIt value for screen
    	 */

		var currentDate = new Date();
		currentDate.setHours(0,0,0,0)
		var tDate = new Date("04/23/2024")
		if(tDate <= currentDate
			&& document.getElementById("fileTemplateHotlink") != null
			&& document.getElementById("fileTemplateHotlink") != undefined)
		{
			document.getElementById("fileTemplateHotlink").style.display = "none";
		}

    	proposalCtr.init = function(){
    		receiptScope.title = CONST_RECEIPT.PROPOSAL_PAGE_TITLE;
    		proposalCtr.datePickerOpenStatus = {};
    		proposalCtr.datePickerOpenStatus.receiptAgDate = false;
    		proposalCtr.datePickerOpenStatus.bankReceiptBrDate = false;
    		proposalCtr.isAgent = true;
    		receiptScope.isSendToBom = false;
    		receiptScope.isDisable = false;
    		receiptScope.isRemoveCorporation = false;
    		receiptScope.isTrrb = false;
    		receiptScope.copyEntity = {};
    		receiptScope.checkAgent = false;
    		proposalCtr.validPruquoteCode = false;
    		CommonService.query({masterurl:'nationality'},function(result) {
    			proposalCtr.lstNationality = result;
    		});
    		
    		CommonService.query({masterurl:'province'},function(result) {
    			proposalCtr.lstProvince = result;
    		});
    		if(entity != null){
    			receiptScope.checkAgent = true;
    			receiptScope.receiptsMustPrint = entity.receiptsMustPrint;
    			receiptScope.txnId = entity.transaction.txnId;
    			receiptScope.receiptId = entity.receiptId;
    			receiptScope.paymentTypeCode = entity.paymentTypeCode;
    			
    			// ETRRB
    			if($state.params.etrrbReceiptId != null || entity.eTrrbReceiptId != null) {
    				receiptScope.isTrrb = true;
    				receiptScope.isDisable = true;
    			}
    			// End ETRRB
    			receiptScope.receipt = entity;
    			if(entity.paymentTypeCode != 'CASH')
				{
    				if(entity.bankReceiptBrNum != null) {
    					proposalCtr.isAgent = true;
    				}else {
    					proposalCtr.isAgent = false;
    				}
    				self.bankPosts = CommonService.query({masterurl:'get-bank-post',paymentType:entity.paymentTypeCode}, function(result) {
        	    		self.bankPosts = result;
        			});
				}else {
					if(entity.receiptAgNum != null) 
						proposalCtr.isAgent = true;
					else
						proposalCtr.isAgent = false;
				}
    			//set to current scope
    			self.receipt = entity;
    			// Neu transaction sucess -> disable
    			if(entity.receiptNum != null)
    			{
    				receiptScope.isDisable = true;
    				ReceiptService.returnValue({uri:'get-tax-invoice-no',receiptNum:entity.receiptNum},function(result) {
						if(result != null && result.response != null && result.response != '')
							self.receipt.taxInvoiceNo = result.response;
					})
    			}
    			
    			if(entity.transaction.wfStatus == 'RECEIPT_END') {
    				receiptScope.isTrrb = false;
    			}
    				
    			if(entity.proposal.customer.customerType === CONST_RECEIPT.CUSTOMER_TYPE_CORPORATION){
    				//Load district , ward
        			CommonService.query({masterurl:'district',provinceCode:entity.proposal.customer.provinceCode},function(result) {
    					proposalCtr.lstDistrict = result;
    				});
    				CommonService.query({masterurl:'ward',districtCode:entity.proposal.customer.districtCode},function(result) {
    					proposalCtr.lstWard = result;
    				});
    				self.receipt.proposal.customer.provinceCode = entity.proposal.customer.provinceCode;
    				self.receipt.proposal.customer.districtCode = entity.proposal.customer.districtCode;
    				self.receipt.proposal.customer.wardCode = entity.proposal.customer.locationCode;
    				
    				if(entity.proposal.customer.clientCode == null)
    					self.receipt.isCallClientActionA = true;
    			}
    			if ($stateParams.etrrbReceiptId != undefined && $stateParams.etrrbReceiptId != '') {
    				self.receipt.eTrrbReceiptId = $base64.decode($stateParams.etrrbReceiptId);
    				if ($stateParams.taskId != undefined && $stateParams.taskId != '') self.receipt.taskInstanceId = $base64.decode($stateParams.taskId);
    				receiptScope.isDisable = true;
    				receiptScope.isTrrb = true;
    			}else if (entity.eTrrbReceiptId != undefined && entity.eTrrbReceiptId != null && entity.transaction.wfStatus !== 'RECEIPT_END') {
    				self.receipt.eTrrbReceiptId = entity.eTrrbReceiptId;
    				if ($stateParams.taskId != undefined && $stateParams.taskId != '') self.receipt.taskInstanceId = $base64.decode($stateParams.taskId);
    				receiptScope.isDisable = true;
    				receiptScope.isTrrb = true;
    			}else if ($stateParams.taskId != undefined && $stateParams.taskId != '') {
        			self.receipt.taskInstanceId = $base64.decode($stateParams.taskId);
        			receiptScope.isDisable = false;
    			}else{
    				receiptScope.isDisable = true;
    				receiptScope.isTrrb = false;
    			}
    			console.log($stateParams.etrrbReceiptId);
    			console.log(self.receipt.taskInstanceId);
    			angular.copy(entity, receiptScope.copyEntity);
    		}else{ // new
    			receiptScope.receipt ={ transaction:{txnType: CONST_RECEIPT.TRANSACTION_TYPE_PROPOSAL, txnEnable:1}, proposal: {customer:{customerType: proposalCtr.getCustomerType()}}};    	
        		self.receipt.paymentTypeCode = 'CASH';
        		self.receipt.receiptAgAmount = 0;
        		self.receipt.bankReceiptBrAmount = 0;
        		self.receipt.receiptTopupAmount = 0;
            	if(self.receipt.proposal.customer.customerType === CONST_RECEIPT.CUSTOMER_TYPE_CORPORATION){
            		self.receipt.proposal.customer.entity = '1';
            		self.receipt.proposal.customer.usBenOwer = '1';
            		self.receipt.proposal.customer.nationality = 'VN';
            		self.receipt.proposal.customer.organizationTypeCode = 'OTHER';
            		self.receipt.proposal.customer.compCode = '84';
            		self.receipt.proposal.customer.mobileCode = '84';
            		self.receipt.isCallClientActionA = false;
            		proposalCtr.customerTemp = angular.copy(self.receipt.proposal.customer);
            	}     
            	//self.receipt.receiptAgDate = new Date();
            	//set to current scope
            	self.receipt = receiptScope.receipt;
            	
    		}
      
    		self.receipt.countSubmit = 0;
    		
    		
    	}	
    	proposalCtr.init();
    	
    	proposalCtr.changeAgent = function(paymentType,value){
    		receiptScope.checkAgent = false;
    		if(paymentType == 'CASH'){
    			if(value) {
    				self.receipt.receiptAgDate = null;
    				self.receipt.receiptAgNum = null;
    			}else {
    				self.receipt.receiptAgentCode = null;
    				self.receipt.receiptAgentName = null;
    				self.receipt.receiptAgNum = null;
    				self.receipt.receiptAgDate = new Date();
    			}
    		}
    	}
    	
    	proposalCtr.changePaymentType = function(code){
    		proposalCtr.isAgent = true;
    		self.receipt.proposal.paymentTypeCode = code;
    		if(code == 'CASH'){
    			proposalCtr.ckAgent = false;
    			self.receipt.bankReceiptBrNum = null;
    			self.receipt.bankReceiptBankAmount = null;
				self.receipt.bankReceiptBrDate = null;
				self.receipt.bankReceiptBankDate = null;
    			if(self.receipt.eTrrbReceiptId != null && (self.receipt.eTrrbReceiptId != undefined || self.receipt.eTrrbReceiptId != '')) {
    				self.receipt.receiptAgNum = receiptScope.copyEntity.receiptAgNum == null ? receiptScope.copyEntity.bankReceiptBrNum : receiptScope.copyEntity.receiptAgNum;
    				self.receipt.receiptAgDate = receiptScope.copyEntity.receiptAgDate == null ? receiptScope.copyEntity.bankReceiptBrDate : receiptScope.copyEntity.receiptAgDate;
    				self.receipt.receiptTotalAmount = receiptScope.copyEntity.receiptAgAmount;
    			}

				if(self.receipt.proposal.proposalNum.substring(0,2) == 15)
				{
					var currentDate = new Date();
					currentDate.setHours(0,0,0,0)
					var tDate = new Date("04/23/2024")
					if(tDate.AddDays(-7) <= currentDate
						&& tDate.AddDays(6) >= currentDate)
					{
						tDate.AddDays(1);
						var stringTDate =  ((tDate.getDate() > 9) ? tDate.getDate() : ('0' + tDate.getDate())) +  '/' + ((tDate.getMonth() > 8) ? (tDate.getMonth() + 1) : ('0' + (tDate.getMonth() + 1))) +'/' + tDate.getFullYear();
						self.addAlert('Kể từ ngày ' + stringTDate + ', hệ thống sẽ không cho phép thực hiện tiếp nhận và nhập thông tin HSYCBH bản giấy. Anh/Chị lưu ý hoàn tất việc nộp HSYCBH bản giấy về Prudential trước ngày ' + stringTDate + ' cũng như thông báo đến Tư vấn viên. Sau ngày ' + stringTDate + ', Anh/chị vui lòng sử dụng hệ thống Prudaily để điền và nộp HSYCBH. Cám ơn sự hợp tác của các Anh/Chị. Trân Trọng','warning');
					}
					else
					{
						tDate = new Date("04/23/2024")
						if(tDate <= currentDate)
						{
							var stringTDate =  ((tDate.getDate() > 9) ? tDate.getDate() : ('0' + tDate.getDate())) +  '/' + ((tDate.getMonth() > 8) ? (tDate.getMonth() + 1) : ('0' + (tDate.getMonth() + 1))) +'/' + tDate.getFullYear();
							self.addAlert('Anh/Chị không thể thực hiện giao dịch thu phí này do Công ty đã dừng sử dụng HSYCBH giấy từ ngày ' + stringTDate + '. Trân Trọng','danger');
							self.receipt.proposal.proposalNum = "";
						}
					}
				}
    		}else {
    			self.bankPosts = CommonService.query({masterurl:'get-bank-post',paymentType:code}, function(result) {
    	    		self.bankPosts = result;
    			});
    			if(code == 'OTHER') {
    				self.receipt.receiptAgentCode = null;
    				self.receipt.receiptAgentName = null;
    			}
    			self.receipt.receiptAgNum = null;
    			self.receipt.bankReceiptBrDate = new Date();
    			self.receipt.bankReceiptBankDate = new Date();
    			if(self.receipt.eTrrbReceiptId != null && (self.receipt.eTrrbReceiptId != undefined || self.receipt.eTrrbReceiptId != '')) {
    				self.receipt.bankReceiptBankAmount = receiptScope.copyEntity.receiptAgAmount;
    				self.receipt.bankReceiptBrAmount = receiptScope.copyEntity.receiptAgAmount;
    				self.receipt.bankReceiptBrNum = receiptScope.copyEntity.receiptAgNum == null ? receiptScope.copyEntity.bankReceiptBrNum : receiptScope.copyEntity.receiptAgNum;
    				self.receipt.receiptTotalAmount = receiptScope.copyEntity.receiptAgAmount;
    				self.receipt.receiptAgentCode = receiptScope.copyEntity.receiptAgentCode;
    				self.receipt.receiptAgentName = receiptScope.copyEntity.receiptAgentName;
    				self.receipt.bankReceiptBrDate = receiptScope.copyEntity.receiptAgDate == null ? receiptScope.copyEntity.bankReceiptBrDate : receiptScope.copyEntity.receiptAgDate;
    				self.receipt.bankReceiptBankDate = receiptScope.copyEntity.receiptAgDate == null ? receiptScope.copyEntity.bankReceiptBrDate : receiptScope.copyEntity.receiptAgDate;
    			}
    			proposalCtr.ckAgent = true;

				if(code == 'OTHER' && self.receipt.proposal.proposalNum.substring(0,2) == 15)
				{
					var currentDate = new Date();
					currentDate.setHours(0,0,0,0)
					var tDate = new Date("04/23/2024")
					if(tDate.AddDays(-7) <= currentDate
						&& tDate.AddDays(6) >= currentDate)
					{
						tDate.AddDays(1);
						var stringTDate =  ((tDate.getDate() > 9) ? tDate.getDate() : ('0' + tDate.getDate())) +  '/' + ((tDate.getMonth() > 8) ? (tDate.getMonth() + 1) : ('0' + (tDate.getMonth() + 1))) +'/' + tDate.getFullYear();
						self.addAlert('Kể từ ngày ' + stringTDate + ', hệ thống sẽ không cho phép thực hiện tiếp nhận và nhập thông tin HSYCBH bản giấy. Anh/Chị lưu ý hoàn tất việc nộp HSYCBH bản giấy về Prudential trước ngày ' + stringTDate + ' cũng như thông báo đến Tư vấn viên. Sau ngày ' + stringTDate + ', Anh/chị vui lòng sử dụng hệ thống Prudaily để điền và nộp HSYCBH. Cám ơn sự hợp tác của các Anh/Chị. Trân Trọng','warning');
					}
					else
					{
						tDate = new Date("04/23/2024")
						if(tDate <= currentDate)
						{
							var stringTDate =  ((tDate.getDate() > 9) ? tDate.getDate() : ('0' + tDate.getDate())) +  '/' + ((tDate.getMonth() > 8) ? (tDate.getMonth() + 1) : ('0' + (tDate.getMonth() + 1))) +'/' + tDate.getFullYear();
							self.addAlert('Anh/Chị không thể thực hiện giao dịch thu phí này do Công ty đã dừng sử dụng HSYCBH giấy từ ngày ' + stringTDate + '. Trân Trọng','danger');
							self.receipt.proposal.proposalNum = "";
						}
					}
				}
    		}
    	};
    	
    	/*
    	 * Build datetime picker
    	 */
    	proposalCtr.openCalendar = function (date) {
        	proposalCtr.datePickerOpenStatus[date] = true;
        }
    	
    	proposalCtr.getAllDistrictByProvince = function(){
    		if (self.receipt.proposal.customer.provinceCode != null || self.receipt.proposal.customer.provinceCode != undefined){
    			CommonService.query({masterurl:'district',provinceCode:self.receipt.proposal.customer.provinceCode},function(result) {
					proposalCtr.lstDistrict = result;
				});
    		}else{
    			proposalCtr.lstDistrict = null;
    		}
    	}
    	
    	proposalCtr.getAllWardByDistrict = function(){
    		if (self.receipt.proposal.customer.districtCode != null || self.receipt.proposal.customer.districtCode != undefined){
    			CommonService.query({masterurl:'ward',districtCode:self.receipt.proposal.customer.districtCode},function(result) {
					proposalCtr.lstWard = result;
				});
    		}else{
    			proposalCtr.lstWard = null;
    		}
    	}
    	
    	proposalCtr.checkClearDataCorp = 0;
    	/*
    	 * Get ID NUM FOR CORPORATION
    	 */
    	function getCustomerByIdNum(idNum, $event){
    		if (idNum == undefined || idNum == null) return false;
    		if($event == undefined) return false;
    		self.clearMessage();
    		receiptScope.loading = true;
    		proposalCtr.customerTempNew = angular.copy(self.receipt.proposal.customer);
    		proposalCtr.lstCustomer = CustomerService.getCustomers({uri:'get-customers-by-idnum', idNum:idNum}, function(data){
    			if(data.length == null || data.length <= 0)
    			{
    				self.receipt.isCallClientActionA = true;
    				if(proposalCtr.checkClearDataCorp > 0){
    					self.receipt.proposal.customer = proposalCtr.customerTemp;
						self.receipt.proposal.customer.idNum = idNum;
    				}
    				self.addAlert('GPKD [' + idNum + '] không tồn tại.Vui lòng kiểm tra lại, hoặc nhập mới thông tin doanh nghiệp.','warning');
    			} else if(data.length == 1)
				{
    				proposalCtr.checkClearDataCorp = proposalCtr.checkClearDataCorp + 1;
    				receiptScope.isRemoveCorporation = false;
    				self.receipt.isCallClientActionA = false;
    				self.receipt.proposal.customer = data[0];
    				if(data[0].nationality == null || data[0].nationality.trim() == '')
    					self.receipt.proposal.customer.nationality = 'VN';
    				self.receipt.proposal.customer.entity = '2';
            		self.receipt.proposal.customer.usBenOwer = '2';
            		if(data[0].organizationTypeCode == null)
            			self.receipt.proposal.customer.organizationTypeCode = 'OTHER';
    				CommonService.query({masterurl:'district',provinceCode:data[0].provinceCode},function(result) {
    					proposalCtr.lstDistrict = result;
    				});
    				CommonService.query({masterurl:'ward',districtCode:data[0].districtCode},function(result) {
    					proposalCtr.lstWard = result;
    				});
    				if(data[0].locationCode != null) {
    					self.receipt.proposal.customer.locationCode = data[0].locationCode;
    				}
    				
    				self.receipt.proposal.customer.provinceCode = data[0].provinceCode;
    				self.receipt.proposal.customer.districtCode = data[0].districtCode;
    				self.receipt.proposal.customer.wardCode = data[0].locationCode;
				}
    			else {
    				proposalCtr.checkClearDataCorp = proposalCtr.checkClearDataCorp + 1;
    				proposalCtr.animationsEnabled = true;
    				receiptScope.loading = false;
    				var modalInstance = 
    					//show dialog
    					$uibModal.open({
    						animation : proposalCtr.animationsEnabled,
    						templateUrl : '../../partial?uri=ga/receipt/proposal/corporation/corporation-dialog',
    						controller : 'CorporationDialogController as corporationDlgCtr',
    						size : 'lg',
    						resolve : {
    							lstCustomer : function() {
    								return proposalCtr.lstCustomer;//tranfer data for dialog
    							},
    							idNum: function(){
    								return idNum;
    							}
    						}
    				});
    				// result data
					modalInstance.result.then(
							function(selectedItem) {
								self.receipt.proposal.customer = selectedItem;
								CommonService.query({masterurl:'district',provinceCode:data[0].provinceCode},function(result) {
			    					proposalCtr.lstDistrict = result;
			    				});
			    				CommonService.query({masterurl:'ward',districtCode:data[0].districtCode},function(result) {
			    					proposalCtr.lstWard = result;
			    				});
			    				self.receipt.isCallClientActionA = false;
			    				if(selectedItem.nationality == null || selectedItem.nationality.trim() == '')
			    					self.receipt.proposal.customer.nationality = 'VN';
			    				self.receipt.proposal.customer.entity = '2';
			            		self.receipt.proposal.customer.usBenOwer = '2';
			            		if(selectedItem.organizationTypeCode == null)
			            			self.receipt.proposal.customer.organizationTypeCode = 'OTHER';
			            		self.receipt.proposal.customer.provinceCode = selectedItem.provinceCode;
			    				self.receipt.proposal.customer.districtCode = selectedItem.districtCode;
			    				self.receipt.proposal.customer.wardCode = selectedItem.locationCode;
			    				self.receipt.proposal.customer.locationCode = selectedItem.locationCode;
							},
							function(isRemoveCorporation) {
								var idNum = self.receipt.proposal.customer.idNum;
								if(isRemoveCorporation)
								{
									self.receipt.proposal.customer = proposalCtr.customerTemp;
									self.receipt.proposal.customer.idNum = idNum;
								}
								else
								{
									self.receipt.proposal.customer = proposalCtr.customerTempNew;
									self.receipt.proposal.customer.idNum = idNum;
								}
								self.receipt.isCallClientActionA = true;
							});
    			}
    			receiptScope.loading = false;
    		},
    		function(error){
    			receiptScope.loading = false;
    		});
    		
    	}
    	
    	/*
    	 * Check Phone number
    	 */
    	function checkPhoneNumber(phoneNumber){
    		CustomerService.get({uri:'check-phone-number', phoneNumber:phoneNumber}, function (result){
    			self.editForm.bizPhone.$setValidity('bizPhoneIsInvalid',true);
    		},
    		function (error) {
    			self.editForm.bizPhone.$setValidity('bizPhoneIsInvalid',false);
    		});
    	}
    	
    	/*
    	 * Check Proposal Num is exist
    	 */
    	function checkProposalNumIsExist(proposalNum){
    		self.clearMessage();
    		if (proposalNum == undefined || proposalNum == null) return false;
    		if (proposalNum.substring( 0, 1) == 0) {
    			self.editForm.proposalNum.$setValidity('startsWith0ProposalNum',false);
    			return;
    		}
    		else {
    			self.editForm.proposalNum.$setValidity('startsWith0ProposalNum',true);
    		}
    		ReceiptService.get({uri:'check-proposal-num-to-las', proposalNum:proposalNum},function(result){
    			self.editForm.proposalNum.$setValidity('proposalIsExist',true);
    		},
    		function(error)
    		{
    			self.editForm.proposalNum.$setValidity('proposalIsExist',false);
    			return;
    		})

			if(proposalNum.substring(0,2) == 15
				&& (self.receipt.paymentTypeCode == "CASH" || self.receipt.paymentTypeCode == "OTHER"))
			{
				var currentDate = new Date();
				currentDate.setHours(0,0,0,0)
				var tDate = new Date("04/23/2024")
				if(tDate.AddDays(-7) <= currentDate
					&& tDate.AddDays(6) >= currentDate)
				{
					tDate.AddDays(1);
					var stringTDate =  ((tDate.getDate() > 9) ? tDate.getDate() : ('0' + tDate.getDate())) +  '/' + ((tDate.getMonth() > 8) ? (tDate.getMonth() + 1) : ('0' + (tDate.getMonth() + 1))) +'/' + tDate.getFullYear();
					self.addAlert('Kể từ ngày ' + stringTDate + ', hệ thống sẽ không cho phép thực hiện tiếp nhận và nhập thông tin HSYCBH bản giấy. Anh/Chị lưu ý hoàn tất việc nộp HSYCBH bản giấy về Prudential trước ngày ' + stringTDate + ' cũng như thông báo đến Tư vấn viên. Sau ngày ' + stringTDate + ', Anh/chị vui lòng sử dụng hệ thống Prudaily để điền và nộp HSYCBH. Cám ơn sự hợp tác của các Anh/Chị. Trân Trọng','warning');
				}
				else
				{
					tDate = new Date("04/23/2024")
					if(tDate <= currentDate)
					{
						var stringTDate =  ((tDate.getDate() > 9) ? tDate.getDate() : ('0' + tDate.getDate())) +  '/' + ((tDate.getMonth() > 8) ? (tDate.getMonth() + 1) : ('0' + (tDate.getMonth() + 1))) +'/' + tDate.getFullYear();
						self.addAlert('Anh/Chị không thể thực hiện giao dịch thu phí này do Công ty đã dừng sử dụng HSYCBH giấy từ ngày ' + stringTDate + '. Trân Trọng','danger');
						self.receipt.proposal.proposalNum = "";
					}
				}
			}
    	}
    	
    	/*
    	 * Check Amount > 0
    	 */
    	function checkAmountThan0(value){
    		if(value <= 0) {
    			return false;
    		}
    		return true;
    	}
    	
    	/*
    	 * Check currentDate - receiptDate > 3 -> showWarning
    	 */
    	function checkReceiptDate() {
    		self.clearMessage();
    		var currentDate = new Date();
    		if (self.receipt.paymentTypeCode == 'CASH')
	    	{	
    	    	if (self.receipt.receiptAgDate != null && self.editForm.receiptAgDate != null) {
        	        var receiptAgDate = new Date(self.receipt.receiptAgDate);
 
        	        if (currentDate > receiptAgDate.AddDays(3)){
        	        	self.addAlert('Tư vấn viên vi phạm chậm nộp phí quá 3 ngày.','warning');
        	        }
        	        if (Number($filter('date')(self.receipt.receiptAgDate,'yyyyMMdd')) <= Number($filter('date')(currentDate, 'yyyyMMdd'))) {
    	        		self.editForm.receiptAgDate.$setValidity('dateBiggerCurrentDate',true);	
    	        		receiptScope.receiptCtr.checkTrRbNum(self.receipt.paymentTypeCode, 
    						      self.receipt.receiptAgNum, 'TR', 
    						      self.receipt.receiptAgentCode, 
    						      self.receipt.receiptAgDate);
        	        }
        	        else{
        	        	self.editForm.receiptAgDate.$setValidity('dateBiggerCurrentDate',false);
        	        }
        	    }
	    	}
    	    else{
    	    	if (self.receipt.bankReceiptBrDate != null && self.editForm.bankReceiptBrDate != null) {
        	        var bankReceiptBrDate = new Date(self.receipt.bankReceiptBrDate);
 
        	        if (currentDate > bankReceiptBrDate.AddDays(3)){
        	        	self.addAlert('Tư vấn viên vi phạm chậm nộp phí quá 3 ngày.','warning');
        	        }
        	        if (Number($filter('date')(self.receipt.bankReceiptBrDate,'yyyyMMdd')) <= Number($filter('date')(currentDate, 'yyyyMMdd'))) {
        	        	self.editForm.bankReceiptBrDate.$setValidity('dateBiggerCurrentDate',true);	
        	        	receiptScope.receiptCtr.checkTrRbNum(self.receipt.paymentTypeCode, 
    							self.receipt.bankReceiptBrNum, 'TR', 
							      self.receipt.receiptAgentCode, 
							      self.receipt.bankReceiptBrDate);
        	        }
        	        else{
        	        	self.editForm.bankReceiptBrDate.$setValidity('dateBiggerCurrentDate',false);	
        	        }
        	        
        	    }
    	    }
    	}
    	
    	//Add days
    	Date.prototype.AddDays = function(noOfDays) {
    	    this.setTime(this.getTime() + (noOfDays * (1000 * 60 * 60 * 24)));
    	    return this;
    	}
    	
    	
    	
    	/*
    	 * Sum total amount
    	 */
    	self.$watch('receipt.receiptAgAmount', function(newValue, oldValue) {
    		if (!self.editForm.$dirty) return;
    		if(self.receipt.receiptTopupAmount == undefined || self.receipt.receiptTopupAmount == '')
    			self.receipt.receiptTotalAmount = parseFloat(newValue);
    		else
    			self.receipt.receiptTotalAmount = parseFloat(self.receipt.receiptTopupAmount == null ? 0 : self.receipt.receiptTopupAmount) + parseFloat(newValue);
    	});
    	self.$watch('receipt.receiptTopupAmount', function(newValue, oldValue) {
    		if (!self.editForm.$dirty) return;
    		self.receipt.receiptTotalAmount = parseFloat(self.receipt.receiptAgAmount) + parseFloat(newValue);
    	});
    	self.$watch('receipt.bankReceiptBrAmount', function(newValue, oldValue) {
    		if (!self.editForm.$dirty) return;
    		self.receipt.receiptTotalAmount = parseFloat(self.receipt.receiptTopupAmount == null ? 0 : self.receipt.receiptTopupAmount) + parseFloat(newValue);
    	});
    	/*
    	 * Load Topup theo loai san pham la dau tu
    	 */
    	self.$watch('receipt.proposal.productCode', function(newValue){
    		if (!self.editForm.$dirty) return;
    		if(newValue != undefined && newValue != ''){
    			proposalCtr.investment = $filter('filter')(receiptScope.products, {productCode: newValue})[0].investment;
    			if (proposalCtr.investment == 0){
    				self.receipt.receiptTopupAmount = 0;
    				self.receipt.receiptTotalAmount = parseFloat(self.receipt.receiptAgAmount);
    			} else if (proposalCtr.investment == 1){
    				self.receipt.receiptTotalAmount = parseFloat(self.receipt.receiptAgAmount) + parseFloat(self.receipt.receiptTopupAmount);
    			}
    		}
    	});

    	/*
    	 * Loại hình tổ chức/ doanh nghiệp = “Tổ chức tài chính” / “Quỹ tín thác”, 
    	 * 2 op neu chon la co 
    	 * ====> show warning
    	 */
    	proposalCtr.showWarning = function(value) {
    		self.clearMessage();
    		if(value != 'OTHER'){
    			self.addAlert('Kiểm tra lại với tư vấn viên thông tin này.','warning');
    		}
    	};
    	proposalCtr.showWarningEntity = function(value) {
    		self.clearMessage();
    		if(value == "2"){
    			self.addAlert('Kiểm tra lại với tư vấn viên thông tin này.','warning');
    		}
    	};
    	proposalCtr.showWarningUsBenOwer = function(value) {
    		self.clearMessage();
    		if(value == "2"){
    			self.addAlert('Kiểm tra lại với tư vấn viên thông tin này.','warning');
    		}
    	};
    	proposalCtr.warningCorpNameThan40 = function(value) {
    		self.clearMessage();
    		if(value != undefined && value != ''){
    			if(value.length > 40)
    				self.addAlert('Vui lòng kiểm tra lại địa chỉ doanh nghiệp sau khi chuyển về LAS.','warning');
    		}
    	}

    	/*
    	 * Reset data
    	 */
    	proposalCtr.reset = function(){
    		//https://angular-ui.github.io/ui-router/site/#/api/ui.router.state.$state#methods_reload
    		$state.transitionTo($state.current, {}, { 
  			  reload: true, inherit: false, notify: true
  			});
    	}   
    	
    	/*
    	 * Create receipt by proposal
    	 */
    	
    	proposalCtr.save = function () {
    		self.clearMessage();
    		self.receipt.currentUrl = $location.absUrl().split(GLOBAL_URL)[1];
    		if(self.receipt.proposal.customer.locationCode == null || self.receipt.proposal.customer.locationCode == undefined)
    			self.receipt.proposal.customer.locationCode = self.receipt.proposal.customer.wardCode;
    		if (self.receipt.isDataEtrrb != '1') {
	    		ReceiptService.save({uri:"check-audit"}, self.receipt, function(data) {
	    			ReceiptService.save({uri:"check-proposal-link-tr"}, self.receipt, function(data) {
	    				
	    				if (data.flgError == '1') {
	        				var detailMessage = data.messageAuditPopop;
	        				var fileUpload1 = 0;
	        				var fileUpload2 = 0;
	
	    					var modalInstance = $uibModal.open({
	    						animation : true,
	    						templateUrl : GLOBAL_URL
	    						+ 'partial?uri=ga/receipt/proposal/individual/audit-confirm-dialog',
	    						controller : 'AuditConfirmController',
	    						controllerAs : 'vm',
	    						size : 'lg',
	    						resolve : {
	    							detailMessage : function() {
	    								return detailMessage;
	    							},
	    							fileUpload1 : function() {
	    								return fileUpload1;
	    							},
	    							fileUpload2 : function() {
	    								return fileUpload2;
	    							},
	    							receipt : function() {
	    								return self.receipt;
	    							}
	    						}
	    					});
	    					
	    					modalInstance.result.then(function(result) {
	    						if(result =='1') {
	    							ReceiptService.save({uri:"check-expired-tr"}, self.receipt, function(data) {
	    								
	    								if (data.flgError == '1') {
	    			        				var detailMessage = data.messageAuditPopop;
	    			        				var fileUpload1 = 1;
	    			        				var fileUpload2 = 0;
	
	    			    					var modalInstance = $uibModal.open({
	    			    						animation : true,
	    			    						templateUrl : GLOBAL_URL
	    			    						+ 'partial?uri=ga/receipt/proposal/individual/audit-confirm-dialog',
	    			    						controller : 'AuditConfirmController',
	    			    						controllerAs : 'vm',
	    			    						size : 'lg',
	    			    						resolve : {
	    			    							detailMessage : function() {
	    			    								return detailMessage;
	    			    							},
	    			    							fileUpload1 : function() {
	    			    								return fileUpload1;
	    			    							},
	    			    							fileUpload2 : function() {
	    			    								return fileUpload2;
	    			    							},
	    			    							receipt : function() {
	    			    								return self.receipt;
	    			    							}
	    			    						}
	    			    					});
	    			    					
	    			    					modalInstance.result.then(function(result) {
	    			    						if(result =='1') {
	    			    							ReceiptService.save({uri:"check-correct-tr-rb"}, self.receipt, function(data) {
	    			    								if (data.flgError == '1') {
	    			    			        				var detailMessage = data.messageAuditPopop;
	    			    			        				var fileUpload1 = 0;
	    			    			        				var fileUpload2 = 1;
	
	    			    			    					var modalInstance = $uibModal.open({
	    			    			    						animation : true,
	    			    			    						templateUrl : GLOBAL_URL
	    			    			    						+ 'partial?uri=ga/receipt/proposal/individual/audit-confirm-dialog',
	    			    			    						controller : 'AuditConfirmController',
	    			    			    						controllerAs : 'vm',
	    			    			    						size : 'lg',
	    			    			    						resolve : {
	    			    			    							detailMessage : function() {
	    			    			    								return detailMessage;
	    			    			    							},
	    			    			    							fileUpload1 : function() {
	    			    			    								return fileUpload1;
	    			    			    							},
	    			    			    							fileUpload2 : function() {
	    			    			    								return fileUpload2;
	    			    			    							},
	    			    			    							receipt : function() {
	    			    			    								return self.receipt;
	    			    			    							}
	    			    			    						}
	    			    			    					});
	    			    			    					
	    			    			    					modalInstance.result.then(function(result) {
	    			    			    						if(result =='1') {
	    			    			    							saveContinue();
	    			    			    						} else {
	    			    			    							self.receipt.archiveDataReportExpiredTr = null;
	    			    			    							self.receipt.archiveDataReportCorrectTr = null;
	    			    			    						}
	    			    			    						
	    			    			    						receiptScope.loading = false;
	    			    			    					});
	    			    			    					
	    			    								} else {
	    			    									saveContinue();
	    			    								}
	    			    							}, function (error) {
	    			    				        		self.receipt = error.data;
	    			    				        		
	    			    				        		if(error.headers('X-PRUGAGreatApp-error') === 'las.error'){
	    			    				        			self.receipt.countSubmit = self.receipt.countSubmit + 1;
	    			    				        		}
	    			    				        		
	    			    				        		if(error.data.proposal != null) {
	    			    				            		self.receipt.proposal.lasErrorMessage = error.data.proposal.lasErrorMessage;
	    			    				            		self.receipt.proposal.bulkErrorMessage = error.data.proposal.bulkErrorMessage;
	    			    				            		self.receipt.proposal.updatedToLas = error.data.proposal.updatedToLas;
	    			    				        		}
	    			    				        		if(self.receipt.countSubmit >= 2){
	    			    				        			 receiptScope.isDisable = true;
	    			    				        			 self.receipt.proposal.notNullProposal = true;
	    			    				             		 self.receipt.notNullReceiptAGAmount = true;
	    			    				         		}
	    			    				        		 receiptScope.loading = false;
	    			    			    			});
	    			    						} else {
	    			    							self.receipt.archiveDataReportExpiredTr = null;
	    			    							self.receipt.archiveDataReportCorrectTr = null;
	    			    						}
	
	    			    						receiptScope.loading = false;
	    			    					});
	    								} else {
	    									ReceiptService.save({uri:"check-correct-tr-rb"}, self.receipt, function(data) {
			    								if (data.flgError == '1') {
			    			        				var detailMessage = data.messageAuditPopop;
			    			        				var fileUpload1 = 0;
			    			        				var fileUpload2 = 1;
	
			    			    					var modalInstance = $uibModal.open({
			    			    						animation : true,
			    			    						templateUrl : GLOBAL_URL
			    			    						+ 'partial?uri=ga/receipt/proposal/individual/audit-confirm-dialog',
			    			    						controller : 'AuditConfirmController',
			    			    						controllerAs : 'vm',
			    			    						size : 'lg',
			    			    						resolve : {
			    			    							detailMessage : function() {
			    			    								return detailMessage;
			    			    							},
			    			    							fileUpload1 : function() {
			    			    								return fileUpload1;
			    			    							},
			    			    							fileUpload2 : function() {
			    			    								return fileUpload2;
			    			    							},
			    			    							receipt : function() {
			    			    								return self.receipt;
			    			    							}
			    			    						}
			    			    					});
			    			    					
			    			    					modalInstance.result.then(function(result) {
			    			    						if(result =='1') {
			    			    							saveContinue();
			    			    						} else {
			    			    							self.receipt.archiveDataReportExpiredTr = null;
			    			    							self.receipt.archiveDataReportCorrectTr = null;
			    			    						}
			    			    						
			    			    						receiptScope.loading = false;
			    			    					});
			    			    					
			    								} else {
			    									saveContinue();
			    								}
			    							}, function (error) {
			    				        		self.receipt = error.data;
			    				        		
			    				        		if(error.headers('X-PRUGAGreatApp-error') === 'las.error'){
			    				        			self.receipt.countSubmit = self.receipt.countSubmit + 1;
			    				        		}
			    				        		
			    				        		if(error.data.proposal != null) {
			    				            		self.receipt.proposal.lasErrorMessage = error.data.proposal.lasErrorMessage;
			    				            		self.receipt.proposal.bulkErrorMessage = error.data.proposal.bulkErrorMessage;
			    				            		self.receipt.proposal.updatedToLas = error.data.proposal.updatedToLas;
			    				        		}
			    				        		if(self.receipt.countSubmit >= 2){
			    				        			 receiptScope.isDisable = true;
			    				        			 self.receipt.proposal.notNullProposal = true;
			    				             		 self.receipt.notNullReceiptAGAmount = true;
			    				         		}
			    				        		 receiptScope.loading = false;
			    			    			});
	    								}
	    							}, function (error) {
	    				        		self.receipt = error.data;
	    				        		
	    				        		if(error.headers('X-PRUGAGreatApp-error') === 'las.error'){
	    				        			self.receipt.countSubmit = self.receipt.countSubmit + 1;
	    				        		}
	    				        		
	    				        		if(error.data.proposal != null) {
	    				            		self.receipt.proposal.lasErrorMessage = error.data.proposal.lasErrorMessage;
	    				            		self.receipt.proposal.bulkErrorMessage = error.data.proposal.bulkErrorMessage;
	    				            		self.receipt.proposal.updatedToLas = error.data.proposal.updatedToLas;
	    				        		}
	    				        		if(self.receipt.countSubmit >= 2){
	    				        			 receiptScope.isDisable = true;
	    				        			 self.receipt.proposal.notNullProposal = true;
	    				             		 self.receipt.notNullReceiptAGAmount = true;
	    				         		}
	    				        		 receiptScope.loading = false;
	    			    			});
	    						}
	    						
	    						receiptScope.loading = false;
	    					});
	    				} else {
	    					ReceiptService.save({uri:"check-expired-tr"}, self.receipt, function(data) {
								
								if (data.flgError == '1') {
			        				var detailMessage = data.messageAuditPopop;
			        				var fileUpload1 = 1;
			        				var fileUpload2 = 0;
	
			    					var modalInstance = $uibModal.open({
			    						animation : true,
			    						templateUrl : GLOBAL_URL
			    						+ 'partial?uri=ga/receipt/proposal/individual/audit-confirm-dialog',
			    						controller : 'AuditConfirmController',
			    						controllerAs : 'vm',
			    						size : 'lg',
			    						resolve : {
			    							detailMessage : function() {
			    								return detailMessage;
			    							},
			    							fileUpload1 : function() {
			    								return fileUpload1;
			    							},
			    							fileUpload2 : function() {
			    								return fileUpload2;
			    							},
			    							receipt : function() {
			    								return self.receipt;
			    							}
			    						}
			    					});
			    					
			    					modalInstance.result.then(function(result) {
			    						if(result =='1') {
			    							ReceiptService.save({uri:"check-correct-tr-rb"}, self.receipt, function(data) {
			    								if (data.flgError == '1') {
			    			        				var detailMessage = data.messageAuditPopop;
			    			        				var fileUpload1 = 0;
			    			        				var fileUpload2 = 1;
	
			    			    					var modalInstance = $uibModal.open({
			    			    						animation : true,
			    			    						templateUrl : GLOBAL_URL
			    			    						+ 'partial?uri=ga/receipt/proposal/individual/audit-confirm-dialog',
			    			    						controller : 'AuditConfirmController',
			    			    						controllerAs : 'vm',
			    			    						size : 'lg',
			    			    						resolve : {
			    			    							detailMessage : function() {
			    			    								return detailMessage;
			    			    							},
			    			    							fileUpload1 : function() {
			    			    								return fileUpload1;
			    			    							},
			    			    							fileUpload2 : function() {
			    			    								return fileUpload2;
			    			    							},
			    			    							receipt : function() {
			    			    								return self.receipt;
			    			    							}
			    			    						}
			    			    					});
			    			    					
			    			    					modalInstance.result.then(function(result) {
			    			    						if(result =='1') {
			    			    							saveContinue();
			    			    						} else {
			    			    							self.receipt.archiveDataReportExpiredTr = null;
			    			    							self.receipt.archiveDataReportCorrectTr = null;
			    			    						}
			    			    						
			    			    						receiptScope.loading = false;
			    			    					});
			    			    					
			    								} else {
			    									saveContinue();
			    								}
			    							}, function (error) {
			    				        		self.receipt = error.data;
			    				        		
			    				        		if(error.headers('X-PRUGAGreatApp-error') === 'las.error'){
			    				        			self.receipt.countSubmit = self.receipt.countSubmit + 1;
			    				        		}
			    				        		
			    				        		if(error.data.proposal != null) {
			    				            		self.receipt.proposal.lasErrorMessage = error.data.proposal.lasErrorMessage;
			    				            		self.receipt.proposal.bulkErrorMessage = error.data.proposal.bulkErrorMessage;
			    				            		self.receipt.proposal.updatedToLas = error.data.proposal.updatedToLas;
			    				        		}
			    				        		if(self.receipt.countSubmit >= 2){
			    				        			 receiptScope.isDisable = true;
			    				        			 self.receipt.proposal.notNullProposal = true;
			    				             		 self.receipt.notNullReceiptAGAmount = true;
			    				         		}
			    				        		 receiptScope.loading = false;
			    			    			});
			    						} else {
			    							self.receipt.archiveDataReportExpiredTr = null;
			    							self.receipt.archiveDataReportCorrectTr = null;
			    						}
	
			    						receiptScope.loading = false;
			    					});
								} else {
									ReceiptService.save({uri:"check-correct-tr-rb"}, self.receipt, function(data) {
	    								if (data.flgError == '1') {
	    			        				var detailMessage = data.messageAuditPopop;
	    			        				var fileUpload1 = 0;
	    			        				var fileUpload2 = 1;
	
	    			    					var modalInstance = $uibModal.open({
	    			    						animation : true,
	    			    						templateUrl : GLOBAL_URL
	    			    						+ 'partial?uri=ga/receipt/proposal/individual/audit-confirm-dialog',
	    			    						controller : 'AuditConfirmController',
	    			    						controllerAs : 'vm',
	    			    						size : 'lg',
	    			    						resolve : {
	    			    							detailMessage : function() {
	    			    								return detailMessage;
	    			    							},
	    			    							fileUpload1 : function() {
	    			    								return fileUpload1;
	    			    							},
	    			    							fileUpload2 : function() {
	    			    								return fileUpload2;
	    			    							},
	    			    							receipt : function() {
	    			    								return self.receipt;
	    			    							}
	    			    						}
	    			    					});
	    			    					
	    			    					modalInstance.result.then(function(result) {
	    			    						if(result =='1') {
	    			    							saveContinue();
	    			    						} else {
	    			    							self.receipt.archiveDataReportExpiredTr = null;
	    			    							self.receipt.archiveDataReportCorrectTr = null;
	    			    						}
	    			    						
	    			    						receiptScope.loading = false;
	    			    					});
	    			    					
	    								} else {
	    									saveContinue();
	    								}
	    							}, function (error) {
	    				        		self.receipt = error.data;
	    				        		
	    				        		if(error.headers('X-PRUGAGreatApp-error') === 'las.error'){
	    				        			self.receipt.countSubmit = self.receipt.countSubmit + 1;
	    				        		}
	    				        		
	    				        		if(error.data.proposal != null) {
	    				            		self.receipt.proposal.lasErrorMessage = error.data.proposal.lasErrorMessage;
	    				            		self.receipt.proposal.bulkErrorMessage = error.data.proposal.bulkErrorMessage;
	    				            		self.receipt.proposal.updatedToLas = error.data.proposal.updatedToLas;
	    				        		}
	    				        		if(self.receipt.countSubmit >= 2){
	    				        			 receiptScope.isDisable = true;
	    				        			 self.receipt.proposal.notNullProposal = true;
	    				             		 self.receipt.notNullReceiptAGAmount = true;
	    				         		}
	    				        		 receiptScope.loading = false;
	    			    			});
								}
							}, function (error) {
				        		self.receipt = error.data;
				        		
				        		if(error.headers('X-PRUGAGreatApp-error') === 'las.error'){
				        			self.receipt.countSubmit = self.receipt.countSubmit + 1;
				        		}
				        		
				        		if(error.data.proposal != null) {
				            		self.receipt.proposal.lasErrorMessage = error.data.proposal.lasErrorMessage;
				            		self.receipt.proposal.bulkErrorMessage = error.data.proposal.bulkErrorMessage;
				            		self.receipt.proposal.updatedToLas = error.data.proposal.updatedToLas;
				        		}
				        		if(self.receipt.countSubmit >= 2){
				        			 receiptScope.isDisable = true;
				        			 self.receipt.proposal.notNullProposal = true;
				             		 self.receipt.notNullReceiptAGAmount = true;
				         		}
				        		 receiptScope.loading = false;
			    			});
	    				}
	    			}, function (error) {
		        		self.receipt = error.data;
		        		
		        		if(error.headers('X-PRUGAGreatApp-error') === 'las.error'){
		        			self.receipt.countSubmit = self.receipt.countSubmit + 1;
		        		}
		        		
		        		if(error.data.proposal != null) {
		            		self.receipt.proposal.lasErrorMessage = error.data.proposal.lasErrorMessage;
		            		self.receipt.proposal.bulkErrorMessage = error.data.proposal.bulkErrorMessage;
		            		self.receipt.proposal.updatedToLas = error.data.proposal.updatedToLas;
		        		}
		        		if(self.receipt.countSubmit >= 2){
		        			 receiptScope.isDisable = true;
		        			 self.receipt.proposal.notNullProposal = true;
		             		 self.receipt.notNullReceiptAGAmount = true;
		         		}
		        		 receiptScope.loading = false;
	    			});
	        	}, function(error){
	        		self.receipt = error.data;
	        		
	        		if(error.headers('X-PRUGAGreatApp-error') === 'las.error'){
	        			self.receipt.countSubmit = self.receipt.countSubmit + 1;
	        		}
	        		
	        		if(error.data.proposal != null) {
	            		self.receipt.proposal.lasErrorMessage = error.data.proposal.lasErrorMessage;
	            		self.receipt.proposal.bulkErrorMessage = error.data.proposal.bulkErrorMessage;
	            		self.receipt.proposal.updatedToLas = error.data.proposal.updatedToLas;
	        		}
	        		if(self.receipt.countSubmit >= 2){
	        			 receiptScope.isDisable = true;
	        			 self.receipt.proposal.notNullProposal = true;
	             		 self.receipt.notNullReceiptAGAmount = true;
	         		}
	        		 receiptScope.loading = false;
	        	});
    		} else {
    			saveContinue();
    		}
        }
    	
    	function saveContinue() {
    		receiptScope.loading = true;
    		if ((self.receipt.archiveDataReportExpiredTr != null && self.receipt.archiveDataReportExpiredTr != undefined) || 
    				(self.receipt.archiveDataReportCorrectTr != null && self.receipt.archiveDataReportCorrectTr != undefined)) {
	    		var dataFile = [];
	    		var urlFile = "";

	    		if (self.receipt.archiveDataReportExpiredTr != null && self.receipt.archiveDataReportCorrectTr != null) {
	    			dataFile['fileExpired'] = self.receipt.archiveDataReportExpiredTr;
		    		dataFile['fileCorrect'] = self.receipt.archiveDataReportCorrectTr;
	    			urlFile = "save-proposal-temp";
	    		} else if (self.receipt.archiveDataReportExpiredTr != null) {
	    			dataFile['fileExpired'] = self.receipt.archiveDataReportExpiredTr;
	    			urlFile = "save-proposal-temp-fileExpired";
	    		} else {
	    			dataFile['fileCorrect'] = self.receipt.archiveDataReportCorrectTr;
	    			urlFile = "save-proposal-temp-fileCorrect";
	    		}
	    		
				dataFile['receipt'] = new Blob([ JSON
						.stringify(self.receipt) ], {
					type : "application/json"
				});
	    		
				Upload.upload({
					url : GLOBAL_URL
							+ 'api/ga/receipt/' + urlFile,
					data : dataFile
				}).then(function(data){
	        		receiptScope.isDisable = true;
	        		self.receipt.proposal.notNullProposal = true;
	        		self.receipt.notNullReceiptAGAmount = true;
	        		receiptScope.isTrrb = false;
	        		receiptScope.txnId = data.transaction.txnId;
	        		receiptScope.receiptId = data.receiptId;
	        		receiptScope.receiptsMustPrint = data.receiptsMustPrint;
	        		receiptScope.paymentTypeCode = data.paymentTypeCode;
	        		self.receipt = data;
	        		if(data.proposal.customer.customerType === CONST_RECEIPT.CUSTOMER_TYPE_CORPORATION){
	        			self.receipt.proposal.customer.provinceCode = data.provinceCode;
	        			self.receipt.proposal.customer.districtCode = data.districtCode;
	        			self.receipt.proposal.customer.wardCode = data.wardCode;
	        		}
	        		receiptScope.loading = false;
	        		receiptScope.checkContest(data);
	        	}, function(error){
	        		self.receipt = error.data;
	        		
	        		if(error.headers('X-PRUGAGreatApp-error') === 'las.error'){
	        			self.receipt.countSubmit = self.receipt.countSubmit + 1;
	        		}
	        		
	        		if(error.data.proposal != null) {
	            		self.receipt.proposal.lasErrorMessage = error.data.proposal.lasErrorMessage;
	            		self.receipt.proposal.bulkErrorMessage = error.data.proposal.bulkErrorMessage;
	            		self.receipt.proposal.updatedToLas = error.data.proposal.updatedToLas;
	        		}
	        		if(self.receipt.countSubmit >= 2){
	        			 receiptScope.isDisable = true;
	        			 self.receipt.proposal.notNullProposal = true;
	             		 self.receipt.notNullReceiptAGAmount = true;
	         		}
	        		 receiptScope.loading = false;
	        	});
    		} else {
	    		ReceiptService.save({uri:"save-proposal"}, self.receipt, function(data){
	        		receiptScope.isDisable = true;
	        		self.receipt.proposal.notNullProposal = true;
	        		self.receipt.notNullReceiptAGAmount = true;
	        		receiptScope.isTrrb = false;
	        		receiptScope.txnId = data.transaction.txnId;
	        		receiptScope.receiptId = data.receiptId;
	        		receiptScope.receiptsMustPrint = data.receiptsMustPrint;
	        		receiptScope.paymentTypeCode = data.paymentTypeCode;
	        		self.receipt = data;
	        		if(data.proposal.customer.customerType === CONST_RECEIPT.CUSTOMER_TYPE_CORPORATION){
	        			self.receipt.proposal.customer.provinceCode = data.provinceCode;
	        			self.receipt.proposal.customer.districtCode = data.districtCode;
	        			self.receipt.proposal.customer.wardCode = data.wardCode;
	        		}
	        		receiptScope.checkContest(data);
	        		//receiptScope.loading = false;
	        	}, function(error){
	        		self.receipt = error.data;
	        		
	        		if(error.headers('X-PRUGAGreatApp-error') === 'las.error'){
	        			self.receipt.countSubmit = self.receipt.countSubmit + 1;
	        		}
	        		
	        		if(error.data.proposal != null) {
	            		self.receipt.proposal.lasErrorMessage = error.data.proposal.lasErrorMessage;
	            		self.receipt.proposal.bulkErrorMessage = error.data.proposal.bulkErrorMessage;
	            		self.receipt.proposal.updatedToLas = error.data.proposal.updatedToLas;
	        		}
	        		if(self.receipt.countSubmit >= 2){
	        			 receiptScope.isDisable = true;
	        			 self.receipt.proposal.notNullProposal = true;
	             		 self.receipt.notNullReceiptAGAmount = true;
	         		}
	        		 receiptScope.loading = false;
	        	});
	        }
    	}
    	/*
    	 * Update status receipt when las suscess and prugreat fail
    	 */
    	proposalCtr.updateReceipt = function () {
    		self.clearMessage();
    		receiptScope.loading = true;
    		ReceiptService.save({uri:"update-receipt"}, self.receipt, function(data){
        		receiptScope.isDisable = true;
        		receiptScope.txnId = data.transaction.txnId;
        		receiptScope.receiptId = data.receiptId;
        		receiptScope.receiptsMustPrint = data.receiptsMustPrint;
        		receiptScope.paymentTypeCode = data.paymentTypeCode;
        		self.receipt = data;
        		if(data.proposal.customer.customerType === CONST_RECEIPT.CUSTOMER_TYPE_CORPORATION){
        			self.receipt.proposal.customer.provinceCode = data.provinceCode;
        			self.receipt.proposal.customer.districtCode = data.districtCode;
        			self.receipt.proposal.customer.wardCode = data.wardCode;
        		}
        		receiptScope.loading = false;
        	}, function(error){
        		 receiptScope.loading = false;
        	});
        }
    	
    	proposalCtr.sendToBom = function () {
    		self.clearMessage();
    		self.receipt.currentUrl = $location.absUrl().split(GLOBAL_URL)[1];
    		receiptScope.loading = true;
    	
    		ReceiptService.save({uri:"send-to-bom"},self.receipt, function(data){
        		receiptScope.isDisable = true;
        		receiptScope.isSendToBom = true;
        		//receiptScope.loading = false;
        		receiptScope.txnId = data.transaction.txnId;
        		receiptScope.receiptId = data.receiptId;
        		
        		receiptScope.checkContest(data);
        	}, function(error){
        		receiptScope.loading = false;
        	});
        }
    	
    	function setLocationCode(wardCode) {
    		self.receipt.wardCode = wardCode;
    		self.receipt.proposal.customer.locationCode = wardCode;
    	}
    	
    	/*
    	 * Receipt cancel reason
    	 */
    	function receiptCancelReason(receiptId){
    		if (receiptId == undefined || receiptId == null) return false;
    		proposalCtr.lstReceiptCancelReason = ReceiptService.query({uri:'receipt-cancel-reason'}, function(data){
    			proposalCtr.animationsEnabled = true;
				var modalInstance = 
					//show dialog
					$uibModal.open({
						animation : proposalCtr.animationsEnabled,
						templateUrl : GLOBAL_URL+ 'partial?uri=ga/receipt/receipt-cancel-reason-dialog',
						controller : 'ReceiptCancelReasonDialogController as cancelReasonDlgCtr',
						size : 'lg',
						resolve : {
							lstReceiptCancelReason : function() {
								return data;//tranfer data for dialog
							},
							receipt: function(){
								return self.receipt;
							}
						}
				});
				modalInstance.result.then(
						function(result) {
							self.receipt = result;
							self.receipt.transaction.busWfCode = 'CANCELED';
							self.receipt.transaction.txnEnable = '0';
							receiptScope.isDisableCancelReason = true;
							receiptScope.isDisable = true;
							self.isRevert = true;
						},
						function(error){
						});
    		},
    		function(error){
    		});
    		
    	}
    	
    	function startsWithProposalETrrb(printstatus) {
    		if(printstatus != null && printstatus != undefined) {
    			if(printstatus != 3001 || printstatus != 3002 || printstatus != 4001 || printstatus != 4002) {
    				
    			}
    		}
    		return false;
    	}
    	
    	proposalCtr.revertReceipt = function(){
    		self.loading = true;
    		self.clearMessage();
    		var handlerData = {'txnId': receiptScope.txnId};
    		ReceiptService.post({uri:'submit-receipt-cancel-to-success'}, handlerData,function(result){
    			self.loading = false;
    			self.receipt.cancelReasonCode = null;
    			self.receipt.transaction.cancelReasonCode = null;
    			self.receipt.transaction.txnEnable = '1';
    			self.receipt.transaction.busWfCode = 'SUCCESS';
    			self.isRevert = false;
			},
			function(error){
				self.loading = false;
			});
		}
    	
    	function checkRuleAgent(agentCode, productCode) {
    		self.clearMessage();
    		
    		self.frequencys = CONST_COMMON.PROPOSAL_FREQUENCYS;
    		if (productCode != undefined && productCode != '') {
    			if (productCode == 'TH2' || productCode == 'TH3') {
    				self.frequencys = CONST_COMMON.TH2_TH3_FREQUENCYS;
    			}
    		}
    		
    		if(agentCode != undefined && agentCode != '' && productCode != undefined && productCode != ''){
    			receiptScope.loading = true;
    			CommonService.get({masterurl:'check-rule-agent-product-in-las',agentCode:agentCode, productCode:productCode},function(result) {
        			receiptScope.loading = false;
        			if(result.messages == null) {
        				self.editForm.receiptAgentCode.$setValidity('checkRuleAgent',true);	
        				receiptScope.checkAgent = true;
        			}else {
        				self.editForm.receiptAgentCode.$setValidity('checkRuleAgent',false);	
        				receiptScope.checkAgent = false;
        			}
    			},function(error) {
    				receiptScope.loading = false;
    				receiptScope.checkAgent = false;
    				self.editForm.receiptAgentCode.$setValidity('checkRuleAgent',false);	
    			});
    		}
    	}
    	
    	function getPruquoteCode(pruquoteCode, agentCode,proposalNum,receipDate, bankReceiptBrDate) {
    		self.clearMessage();
    		proposalCtr.validPruquoteCode = false;
    		if(pruquoteCode != undefined && pruquoteCode != '' 
    				&& agentCode != undefined && agentCode != ''
    					&& proposalNum != undefined && proposalNum != ''){
    			var currtentDate = $filter('date')(new Date(), 'dd/MM/yyyy');
    			if(receipDate != undefined && receipDate != '' && self.receipt.paymentTypeCode == 'CASH') {
    				currtentDate = $filter('date')(receipDate, 'dd/MM/yyyy');
    			} else if(bankReceiptBrDate != undefined && bankReceiptBrDate != '' && self.receipt.paymentTypeCode != 'CASH') {
    				currtentDate = $filter('date')(bankReceiptBrDate, 'dd/MM/yyyy');
    			}
    			receiptScope.loading = true;
    			ReceiptService.get({uri:'get-pruquote-code',
    				pruquoteCode:pruquoteCode, 
    				agentCode:agentCode,
    				proposalNum:proposalNum,
    				receiptDate:currtentDate
				},function(result) {
					self.receipt.proposal.investmentFund = result;
        			receiptScope.loading = false;
    			},function(error) {
    				receiptScope.loading = false;
    				self.addAlert('Minh họa số không tìm thấy hoặc không hỗ trợ sản phẩm này.',
					'danger');
    			});
    		}
    	}
    	
    	function checkPruquoteCode() {
    		self.clearMessage();
    		if(self.receipt.proposal.investmentFund.dob1 != null && self.receipt.proposal.investmentFund.dob2 != null) {
    			var dob1 = $filter('date')(self.receipt.proposal.investmentFund.dob1, 'dd/MM/yyyy');
    			var dob2 = $filter('date')(self.receipt.proposal.investmentFund.dob2, 'dd/MM/yyyy');
    			if(dob1 != dob2) {
    				self.addAlert('Ngày sinh 1 và ngày sinh 2 không giống nhau.','danger');
    				proposalCtr.validPruquoteCode = false;
        			return false;
    			}
    		}else {
    			proposalCtr.validPruquoteCode = false;
    			return false;
    		}
    		if(self.receipt.proposal.investmentFund.age1 != self.receipt.proposal.investmentFund.age2) {
    			self.addAlert('Tuổi 1 và tuổi 2 không giống nhau.','danger');
    			proposalCtr.validPruquoteCode = false;
    			return false;
    		}
    		if(self.receipt.proposal.investmentFund.percentUeq1 == null
    				||  self.receipt.proposal.investmentFund.percentUgr1 == null
    				|| self.receipt.proposal.investmentFund.percentUbl1 == null
    				|| self.receipt.proposal.investmentFund.percentUsb1 == null
    				|| self.receipt.proposal.investmentFund.percentUfi1 == null
    				|| self.receipt.proposal.investmentFund.percentUps1 == null
    				|| self.receipt.proposal.investmentFund.percentUse1 == null
    				|| self.receipt.proposal.investmentFund.percentUeq2 == null
    				|| self.receipt.proposal.investmentFund.percentUgr2 == null
    				|| self.receipt.proposal.investmentFund.percentUbl2 == null
    				|| self.receipt.proposal.investmentFund.percentUsb2 == null
    				|| self.receipt.proposal.investmentFund.percentUfi2 == null
    				|| self.receipt.proposal.investmentFund.percentUps2 == null
					|| self.receipt.proposal.investmentFund.percentUse2 == null) {
    			proposalCtr.validPruquoteCode = false;
    			self.addAlert('Thông tin giữa HSYCBH và bảng minh họa chưa trùng khớp. Vui lòng kiểm tra lại.','danger');
    			return false;
    		}
    		if(parseFloat(self.receipt.proposal.investmentFund.percentUeq1) +
    				parseFloat(self.receipt.proposal.investmentFund.percentUgr1) +
    						parseFloat(self.receipt.proposal.investmentFund.percentUbl1 ) +
    								parseFloat(self.receipt.proposal.investmentFund.percentUsb1 ) +
    										parseFloat(self.receipt.proposal.investmentFund.percentUfi1 ) +
    												parseFloat(self.receipt.proposal.investmentFund.percentUps1 ) +
														parseFloat(self.receipt.proposal.investmentFund.percentUse1 ) != 100) {
    			proposalCtr.validPruquoteCode = false;
    			self.addAlert('Tổng các quỹ đầu tư phải là 100.','danger');
    			return false;
    		}
    		if(self.receipt.proposal.investmentFund.percentUeq1 != self.receipt.proposal.investmentFund.percentUeq2
    				||  self.receipt.proposal.investmentFund.percentUgr1 != self.receipt.proposal.investmentFund.percentUgr2
    				|| self.receipt.proposal.investmentFund.percentUbl1 != self.receipt.proposal.investmentFund.percentUbl2
    				|| self.receipt.proposal.investmentFund.percentUsb1 != self.receipt.proposal.investmentFund.percentUsb2
    				|| self.receipt.proposal.investmentFund.percentUfi1 != self.receipt.proposal.investmentFund.percentUfi2
    				|| self.receipt.proposal.investmentFund.percentUps1 != self.receipt.proposal.investmentFund.percentUps2
    				|| self.receipt.proposal.investmentFund.percentUse1 != self.receipt.proposal.investmentFund.percentUse2) {
    			self.addAlert('Quỹ đầu tư 1 và quỹ đầu tư 2 không giống nhau.','danger');
    			proposalCtr.validPruquoteCode = false;
    			return false;
    		}
    		proposalCtr.validPruquoteCode = true;
    		self.addAlert('Trùng khớp thông tin giữa HSYCBH và bảng minh họa. Vui lòng chọn gửi giao dịch.','success');
    	}
    	
    	function calculateAgePo2(birthDate,receipDate, bankReceiptBrDate) {
    		self.clearMessage();
    		proposalCtr.validPruquoteCode = false;
    		if(birthDate != undefined && birthDate != ''){
    			var dob2 = $filter('date')(birthDate, 'dd/MM/yyyy');
    			var currtentDate = $filter('date')(new Date(), 'dd/MM/yyyy');
    			if(receipDate != undefined && receipDate != '' && self.receipt.paymentTypeCode == 'CASH') {
    				currtentDate = $filter('date')(receipDate, 'dd/MM/yyyy');
    			} else if(bankReceiptBrDate != undefined && bankReceiptBrDate != '' && self.receipt.paymentTypeCode != 'CASH') {
    				currtentDate = $filter('date')(bankReceiptBrDate, 'dd/MM/yyyy');
    			}
    			receiptScope.loading = true;
    			ReceiptService.get({uri:'calculate-age-po',
    				birthMsDate:dob2, 
    				receiptDate:currtentDate
				},function(result) {
					self.receipt.proposal.investmentFund.age2 = result.age;
        			receiptScope.loading = false;
    			},function(error) {
    				if(self.receipt.paymentTypeCode == 'CASH')
    					calculateAge(birthDate,receipDate);
    				else if(self.receipt.paymentTypeCode != 'CASH')
    					calculateAge(birthDate,bankReceiptBrDate);
    				receiptScope.loading = false;
    			});
    		}
    	}
    	
    	function calculateAgePo1(birthDate,receipDate, bankReceiptBrDate) {
    		self.clearMessage();
    		proposalCtr.validPruquoteCode = false;
    		if(birthDate != undefined && birthDate != ''){
    			var dob1 = $filter('date')(birthDate, 'dd/MM/yyyy');
    			var currtentDate = $filter('date')(new Date(), 'dd/MM/yyyy');
    			if(receipDate != undefined && receipDate != '' && self.receipt.paymentTypeCode == 'CASH') {
    				currtentDate = $filter('date')(receipDate, 'dd/MM/yyyy');
    			} else if(bankReceiptBrDate != undefined && bankReceiptBrDate != '' && self.receipt.paymentTypeCode != 'CASH') {
    				currtentDate = $filter('date')(bankReceiptBrDate, 'dd/MM/yyyy');
    			}
    			receiptScope.loading = true;
    			ReceiptService.get({uri:'calculate-age-po',
    				birthMsDate:dob1, 
    				receiptDate:currtentDate
				},function(result) {
					self.receipt.proposal.investmentFund.age1 = result.age;
        			receiptScope.loading = false;
    			},function(error) {
    				if(self.receipt.paymentTypeCode == 'CASH')
    					calculateAge(birthDate,receipDate);
    				else if(self.receipt.paymentTypeCode != 'CASH')
    					calculateAge(birthDate,bankReceiptBrDate);
    				receiptScope.loading = false;
    			});
    		}
    	}
    	
    	proposalCtr.calculateAge = function calculateAge(birthday,current) { // birthday is a date
    		if(birthday != undefined && birthday != '' 
				&& current != undefined && current != ''){
    			 var ageDifMs = current - birthday;
	    	    var ageDate = new Date(ageDifMs); // miliseconds from epoch
	    	    self.receipt.proposal.investmentFund.age2 = Math.abs(ageDate.getUTCFullYear() - 1970);
    		}
    	   }
    	proposalCtr.changeInfoPruquote = function () {
    		proposalCtr.validPruquoteCode = false;
    	}
    }
})();
